import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { CircleWarning } from '@agendapro/emerald-icons';
import { Icon, Paragraph, Link } from '@/UI';
import * as St from './InactiveNotice.styles';
import usePageContext from '@/hooks/usePageContext';
import { GlobalContentLayout } from '../Layouts';

export const InactiveNotice: FC = () => {
  const { t } = useTranslation();
  const { companyOverview } = usePageContext();

  return (
    <St.Wrapper data-testid="inactiveNotice">
      <GlobalContentLayout>
        <St.MainContent>
          <St.WarningContainer>
            <Icon icon={<CircleWarning size={16} color="white" />} />
          </St.WarningContainer>
          <Paragraph size="subHeadline">
            {companyOverview?.isCustomerActive ? t('NOT_TAKING_RESERVES_NOW') : t('INACTIVE_COMPANY_GET_IN_TOUCH')}
          </Paragraph>
        </St.MainContent>

        {!companyOverview?.isCustomerActive && (
          <St.LinkContainer>
            <Paragraph>{t('GET_REGISTERED_FOR_FREE')}</Paragraph>
            <Link href="https://www.agendapro.com/" isUnderlined>
              www.agendapro.com
            </Link>
          </St.LinkContainer>
        )}
      </GlobalContentLayout>
    </St.Wrapper>
  );
};
